import { startMicroscope } from "./initialize";
import { buildApolloClient } from "./core/private/lib/apollo";
import config from "./core/private/config";

const apolloClient = buildApolloClient(`${config.apiUrl}/api/v2/graphql`);

startMicroscope({
  apolloClient
});
